/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
function getPartial(content, selector) {
  return $("<div>").append($.parseHTML(content)).find(selector).children();
}

$(document).on("ready turbo:load", function () {
  const forms = $(".js-previewSearch");
  forms.each(function (index, element) {
    const overlay = $(element).find(".js-previewSearch-results");
    const input = $(element).find(".js-previewSearch-input");
    const form = $(element);
    let results = $("non-existing-element");
    let request = null;
    let activeIndex = -1;
    let isNavigating = false;

    const arrowDown = function () {
      if (activeIndex < results.length - 1) {
        activeIndex++;
      }
      updateView();
    };

    const arrowUp = function () {
      if (activeIndex > -1) {
        activeIndex = (activeIndex - 1) % results.length;
      }
      updateView();
    };

    const confirm = () =>
      (document.location = $(results.get(activeIndex)).find("a").get(0).href);
    const cancel = function () {
      input.blur();
      input.removeClass("active");
      activeIndex = -1;
      isNavigating = false;
      overlay.hide();
    };

    var updateView = function () {
      results.removeClass("active");
      if (activeIndex === -1) {
        input.focus();
      } else {
        $(results.get(activeIndex)).addClass("active");
        input.blur();
      }
    };

    document.addEventListener("keydown", function (event) {
      event = event || window.event;
      if (isNavigating) {
        switch (event.keyCode) {
          case 13:
            if (activeIndex > -1) {
              confirm();
              event.preventDefault();
            }
            break;
          case 27:
            event.preventDefault();
            cancel();
          case 38:
            arrowUp();
            event.preventDefault();
          case 39:
            if (activeIndex > -1) {
              confirm();
              event.preventDefault();
            }
            break;
          case 40:
            arrowDown();
            event.preventDefault();
        }
      }
    });

    let spinnerStartTime = null;
    const spinnerMinTime = 500;
    let spinnerTimeout = null;

    const hideSpinner = function (loadingSpinner) {
      // Clear any existing timeout
      if (spinnerTimeout) {
        clearTimeout(spinnerTimeout);
        spinnerTimeout = null;
      }

      const currentTime = new Date().getTime();
      if (spinnerStartTime && currentTime - spinnerStartTime < spinnerMinTime) {
        // If less than 500ms have passed, wait until 500ms have passed
        const remainingTime = spinnerMinTime - (currentTime - spinnerStartTime);
        spinnerTimeout = setTimeout(function () {
          loadingSpinner.addClass("hidden");
          spinnerStartTime = null;
          spinnerTimeout = null;
        }, remainingTime);
      } else {
        // If more than 500ms have passed, hide immediately
        loadingSpinner.addClass("hidden");
        spinnerStartTime = null;
      }
    };

    input.on("input", function (event) {
      event.preventDefault();
      const term = input.val();
      let loadingSpinner = $(element).find(".js-search-loading");

      // Clear any existing timeout first
      if (spinnerTimeout) {
        clearTimeout(spinnerTimeout);
        spinnerTimeout = null;
      }

      if (request) {
        request.abort();
        request = null;
      }

      if (term.length > 2) {
        loadingSpinner.removeClass("hidden");
        spinnerStartTime = new Date().getTime();
        request = $.ajax({
          url: `${form.data("path")}?s=${encodeURIComponent(term)}`,
        });
        request.done(function (content) {
          content = getPartial(content, ".js-searchBar-suggestions");
          overlay.html(content);
          results = overlay.find("li");
          request = null;
          input.addClass("active");
          loadingSpinner = $(element).find(".js-search-loading");
          hideSpinner(loadingSpinner);
        });
      } else {
        overlay.empty();
        input.removeClass("active");
        loadingSpinner.addClass("hidden");
      }
    });

    input.on("focus", function () {
      isNavigating = true;
      overlay.show();
      if (results.length > 0) {
        input.addClass("active");
      }
    });

    input.on("click", function () {
      activeIndex = -1;
      updateView();
    });

    $(".wrap").click(() => cancel());
  });
});
